import axiosClient from '../config/axios.js';

export async function getOperatorsDatatable({ start = 0, length = 10, search = '', sort = 'id', dir = 'asc' } = {}) {
  const response = await axiosClient.get('/users/operators/datatable', {
    params: {
      start,
      length,
      search,
      sort,
      dir,
    },
  });
  return response.data;
}

export async function updateOperatorFields(id, data) {
  const response = await axiosClient.put(`/users/operators/${id}`, data);
  return response.data;
}
